import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

const KeywordSearch = props => (
  <React.Fragment>
    <div className="caption1 search-caption">Search</div>

    <div className="area keyword-wrapper">
      {props.keywordFilter.length === 0 && (
        <ReactTooltip id="keywordFilterTooltip" />
      )}
      <input
        ref={props.keywordSearchRef}
        data-for="keywordFilterTooltip"
        data-tip="Search in Title and Description"
        type="text"
        id="searchInput"
        value={props.keywordFilter}
        onKeyPress={props.onKeywordKeyPress}
        onChange={props.onKeywordFilterChange}
        placeholder="Search with keywords"
      />
      {props.keywordSearched && (
        <span
          className="clear-keyword-search-icon"
          onClick={props.onClearKeywordSearchClick}
        />
      )}
      <span
        className={`search-icon ${
          props.keywordFilter.length > 0 ? 'active' : ''
        }`}
        onClick={props.onKeywordSearchClick}
      />
    </div>
  </React.Fragment>
)

KeywordSearch.propTypes = {
  keywordFilter: PropTypes.string.isRequired,
  keywordSearchRef: PropTypes.object,
  onKeywordKeyPress: PropTypes.func.isRequired,
  onKeywordFilterChange: PropTypes.func.isRequired,
  keywordSearched: PropTypes.bool.isRequired,
  onClearKeywordSearchClick: PropTypes.func.isRequired,
  onKeywordSearchClick: PropTypes.func.isRequired
}

export default KeywordSearch



// WEBPACK FOOTER //
// ./src/components/mini/SearchInputs/KeywordSearch.js